import styled from "styled-components"

import { minWidth } from "utils"

export const ViewMoreButton = styled.button`
  width: fit-content;
  margin: 4rem auto 0;
  padding: 1.3rem 5.2rem;
  border: 0.1rem solid #222222;
  border-radius: 10rem;
  display: block;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  letter-spacing: 0.172rem;
  text-transform: uppercase;
  cursor: pointer;

  ${minWidth.tablet`
    font-size: 1.6rem;
    line-height: 2.2rem;
    letter-spacing: 0.2rem;
  `}
`
